import snakecaseKeys from 'snakecase-keys'
import axiosIns from '@/plugins/axios'

export default {
  getReferralSales(customerId, {
    startDate = null, endDate = null, page = 1, perPage = 20,
  } = {}) {
    const params = { page, perPage }
    if (startDate) params.startDate = startDate
    if (endDate) params.endDate = endDate

    return axiosIns.get(`/waiter/customers/${customerId}/referral_sales`, {
      params: snakecaseKeys(params),
    })
  },

  getReferralTree(customerId) {
    return axiosIns.get(`/waiter/customers/${customerId}/referral_tree`)
  },

  // 多階層の紹介関係ツリー（関係性ツリー）を取得（期間指定時は各ノードの確定売上を期間で絞る）
  getReferralTreeFull(customerId, { startDate = null, endDate = null } = {}) {
    const params = {}
    if (startDate) params.startDate = startDate
    if (endDate) params.endDate = endDate

    return axiosIns.get(`/waiter/customers/${customerId}/referral_tree_full`, {
      params: snakecaseKeys(params),
    })
  },

  createReferral({ referrerId, referredId }) {
    return axiosIns.post('/waiter/customer_referrals', snakecaseKeys({
      customerReferral: { referrerId, referredId },
    }))
  },

  deleteReferral(id) {
    return axiosIns.delete(`/waiter/customer_referrals/${id}`)
  },
}
